import React, { Component } from 'react';
import { Switch, BrowserRouter as Router, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// Import Routes
import { authProtectedRoutes, publicRoutes } from './routes/';
import AppRoute from './routes/route';

// layouts
import VerticalLayout from './components/VerticalLayout/';
import HorizontalLayout from './components/HorizontalLayout/';
import NonAuthLayout from './components/NonAuthLayout';

// Import scss
import './theme.scss';

import { hot } from 'react-hot-loader';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useGetAuthed from './helpers/hooks/useGetAuthed';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }

  
  CCRpaths = () => ["/baythak", "/post-details/:id", "/baythak/create-announcement", "/users/farmers", "/users/edit-farmer/:id"];

  BApaths = ["/loan-list-bank", '/loan-detail/:id/:loanId','/loan-analytics/:loanId/:id', '/loan-financials/:loanId/:id', '/reset-password']

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case 'horizontal':
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  // requireAdminFn = (route) => {
  //   if{
  //     return true;
  //   }
  //   return false;
  // }
  render() {
    const Layout = this.getLayout();

    // const requireAdmin = this.requireAdminFn();
    if (!window.location.pathname.includes('/login')) {
      try {
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        const loanAuth = JSON.parse(localStorage.getItem('loanAuth'));
        const bankAdmin = JSON.parse(localStorage.getItem('bankAdmin'));

        console.log({bankAdmin})
        if(window.location.pathname.includes('/user-delete')){
          console.log(window.location.pathname)
          this.props.history.push('/user-delete');
          // return;
        }
        if (!authUser && !loanAuth && !bankAdmin) {
          // console.log('if 1')
          window.location.pathname.includes('/user-delete') ? this.props.history.push('/user-delete') : this.props.history.push('/login');
        }

        if (!authUser?.authenticated && !loanAuth?.loan_authenticated && !bankAdmin?.bank_admin_authenticated) {
          // console.log('if 2')
          window.location.pathname.includes('/user-delete') ? this.props.history.push('/user-delete') : this.props.history.push('/login');
        }
      } catch (error) {
        // console.log('error', error)
        this.props.history.push('/login');
      }
    }

    return (
      <React.Fragment>
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => {
              const requireAdmin = !(this.CCRpaths().includes(route.path) )? true: false;
              const BApath = this.BApaths.includes(route.path) ? true : false;
              console.log("BApath",BApath)
              return <AppRoute
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                requireAdmin={requireAdmin}
                BApath={BApath}
              />
            })}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default hot(module)(withRouter(connect(mapStateToProps, null)(App)));
